<a [href]="media.Url" [target]="'_blank'" [pTooltip]="media.Nom" *ngFor="let media of medias" style="margin-right: 8px" click-stop-propagation>
  <img [src]="mediaService.getExtensionImage(media.Filename)" style="height: 20px" />
</a>
